import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import Basic from './Basic.vue'
import { useI18n } from 'vue-i18n'
import { isMobile, everpayAppHost } from '../../constants'

// eslint-disable-next-line no-unused-vars

export default /*#__PURE__*/_defineComponent({
  props: {
    scrollTop: null
  },
  setup(__props: any) {

const props = __props as {
  scrollTop: number,
}


const { t } = useI18n()
const handleBtnClick = () => {
  if (isMobile) {
    window.location.href = everpayAppHost
  } else {
    window.open(everpayAppHost)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Basic, {
    "scroll-top": __props.scrollTop,
    "btn-text": _unref(t)('launch_app'),
    onHandleBtnClick: handleBtnClick
  }, null, 8, ["scroll-top", "btn-text"]))
}
}

})